/* eslint-disable no-param-reassign */
import { createReducer } from '@reduxjs/toolkit';
import {
  addSignals,
  loadingSignalShares,
  removeShare,
  reset,
  setSelectedSignal,
  setSignals,
  setSignalShares,
  updateSignalById,
} from './actions';
import { Signal, SignalShare } from './models';

interface StoredSignals {
  [key: string]: Signal;
}

export interface SignalState {
  signals: StoredSignals;
  selectedSignal: string | undefined;
  signalSharesLoading: boolean;
  signalShares: {
    [id: string]: SignalShare;
  };
}

const initialState: SignalState = {
  signals: {},
  signalSharesLoading: false,
  selectedSignal: undefined,
  signalShares: {},
};

// eslint-disable-next-line import/prefer-default-export
export const reducer = createReducer(initialState, (builder) => {
  builder.addCase(updateSignalById, (state, action) => {
    state.signals[action.payload.id] = action.payload;
  });

  builder.addCase(loadingSignalShares, (state, action) => {
    state.signalSharesLoading = action.payload;
  });

  builder.addCase(addSignals, (state, action) => {
    state.signals = {
      ...state.signals,
      ...action.payload,
    };
  });

  builder.addCase(setSignals, (state, action) => {
    state.signals = action.payload;
  });

  builder.addCase(reset, (state) => {
    Object.assign(state, initialState);
  });

  builder.addCase(setSelectedSignal, (state, action) => {
    state.selectedSignal = action.payload;
  });

  builder.addCase(setSignalShares, (state, action) => {
    state.signalShares = {
      ...state.signalShares,
      ...action.payload,
    };
  });

  builder.addCase(removeShare, (state, action) => {
    delete state.signalShares[action.payload];
  });
});
